import { render, staticRenderFns } from "./addCard.vue?vue&type=template&id=69a874e9&scoped=true&"
import script from "./addCard.vue?vue&type=script&lang=js&"
export * from "./addCard.vue?vue&type=script&lang=js&"
import style0 from "./addCard.vue?vue&type=style&index=0&id=69a874e9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a874e9",
  null
  
)

export default component.exports